const setToken = ({ commit }, token) => {
  commit("setToken", token);
};

const setUser = ({ commit }, user) => {
  commit("setUser", user);
};

const setLoader = ({ commit }, loader) => {
  commit("setLoader", loader);
};

const setSnack = ({ commit }, snack) => {
  commit("setSnack", snack);
};

const setType = ({ commit }, type) => {
  commit("setType", type);
};

const setLogin = ({ commit }, login) => {
  commit("setLogin", login);
};

const setMedia = ({ commit }, media) => {
  commit("setMedia", media);
};

const removeMedia = ({ commit }) => {
  commit("removeMedia");
};

const setBooking = ({ commit }, isBooking) => {
  commit("setBooking", isBooking);
};

export {
  setToken,
  setUser,
  setLoader,
  setSnack,
  setType,
  setLogin,
  setMedia,
  removeMedia,
  setBooking
};
